import { render } from "./AccountVerification.vue?vue&type=template&id=43267e51&scoped=true"
import script from "./AccountVerification.vue?vue&type=script&lang=js"
export * from "./AccountVerification.vue?vue&type=script&lang=js"

import "./AccountVerification.vue?vue&type=style&index=0&id=43267e51&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43267e51"]])

export default __exports__